/**
 * Профиль объёма: где торговали, без привязки к тому, когда.
 *
 * Диапазон окна делится на равные ценовые корзины, в каждой копится
 * наторгованный объём. Получается сводная гистограмма поперёк цены:
 * длинная полоса — уровень, вокруг которого рынок провёл больше всего
 * сделок, и куда он чаще возвращается.
 *
 * **Весь объём свечи кладётся в одну корзину — по типичной цене
 * (H+L+C)/3.** Это допущение, и его стоит назвать вслух. Настоящее
 * распределение сделок внутри бара знает только лента, а у нас на входе
 * свеча: где именно внутри диапазона прошёл объём, из неё не следует.
 * Размазать его ровно по всему диапазону — такая же выдумка, только
 * выглядящая аккуратнее: она нарисовала бы торговлю на хвостах, где её
 * могло не быть вовсе. Одна корзина по типичной цене хотя бы честно
 * отвечает на вопрос «около какой цены торговали», а не притворяется,
 * что знает больше.
 *
 * Расчёт повторяет пайн «Выгодные зоны PRO» корзина в корзину: у
 * человека, который смотрит на оба, не должно расходиться ни число, ни
 * картинка.
 */
/**
 * Полосы профиля по последним свечам.
 *
 * Возвращается уже отфильтрованное порогом: слою рисования незачем
 * знать про корзины, которых он не покажет.
 */
export function volumeProfile(candles, options) {
    const bins = Math.max(1, Math.floor(options.bins));
    /*
     * Глубина ограничена тем, что есть.
     *
     * Окно в 300 свечей на ряду из 40 — не ошибка настройки, а обычное
     * начало: история догружается по прокрутке. Профиль считается по
     * имеющемуся, а не отказывается считаться.
     */
    const depth = Math.min(Math.max(1, Math.floor(options.window)), candles.length);
    if (depth === 0)
        return [];
    const slice = candles.slice(candles.length - depth);
    let high = -Infinity;
    let low = Infinity;
    for (const candle of slice) {
        if (candle.high > high)
            high = candle.high;
        if (candle.low < low)
            low = candle.low;
    }
    const range = high - low;
    // Плоский ряд: делить на ноль нечем, да и профиль по одной цене — не
    // профиль.
    if (!Number.isFinite(range) || range <= 0)
        return [];
    const size = range / bins;
    const totals = new Array(bins).fill(0);
    for (const candle of slice) {
        const price = (candle.high + candle.low + candle.close) / 3;
        if (!Number.isFinite(price))
            continue;
        const volume = Number.isFinite(candle.volume) ? candle.volume : 0;
        const slot = Math.max(0, Math.min(bins - 1, Math.floor((price - low) / size)));
        totals[slot] = (totals[slot] ?? 0) + volume;
    }
    let peak = 0;
    for (const value of totals)
        if (value > peak)
            peak = value;
    /*
     * Нулевой пик — не пустой профиль, а отсутствие объёма.
     *
     * Источник может не отдавать объём вовсе (так у рыночных агрегатов).
     * Нарисовать в этом случае ровные полосы значило бы показать
     * торговлю, которой мы не видели.
     */
    if (peak <= 0)
        return [];
    const floor = Math.max(0, Math.min(100, options.threshold)) / 100;
    const bands = [];
    for (let index = 0; index < bins; index += 1) {
        const share = (totals[index] ?? 0) / peak;
        if (share < floor)
            continue;
        const bottom = low + size * index;
        bands.push({ low: bottom, high: bottom + size, share });
    }
    return bands;
}
//# sourceMappingURL=profile.js.map